import { createContext } from 'react'

export const WizardContext = createContext()
